import React from "react";
import styled from "styled-components";
import useConfigs from "../../hooks/useConfigs";


const ContCards = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 1rem;
  margin-top: 5rem;
`;

const CardPregunta = styled.div`
  {
    background-color: ${(props) =>
      props.themeSelected === "light"
        ? props.theme.grisSecundario
        : props.theme.grisTipografia};
    padding: 1rem 2rem;
    max-width: 40%;
    align-self: flex-start;
    box-sizing: border-box;
    border-radius: 5px;

    h3{
      color: ${(props) =>
        props.themeSelected === "light"
            ? props.theme.azulPpal
            : props.theme.blanco
      };
    }

    hr{
      width: 100%;
      background-color: ${(props) =>
        props.themeSelected === "light"
          ? props.theme.azulPpal
          : props.theme.blanco};
    }

    p{
      color: ${(props) =>
        props.themeSelected === "light"
            ? props.theme.grisTipografia
            : props.theme.blanco
      };
    }
  }


  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    max-width: 93%;
  }
`;


export const PreguntasyRespuestas = ({ data }) => {
  
  const { fontSizeMultiplier, theme, themeSelected } = useConfigs();

  return (
    <ContCards 
      fontSizeMultiplier={fontSizeMultiplier}
      theme={theme}
      themeSelected={themeSelected}>
      {data.map((d, i) => (
        <CardPregunta 
        key={i}
        fontSizeMultiplier={fontSizeMultiplier}
        theme={theme}
        themeSelected={themeSelected}>
          <h3>{d.title}</h3>
          <hr />
          <p>{d.answer}</p>
        </CardPregunta>
      ))}
    </ContCards>
  );
};
